var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:Object.assign({}, {'message': true,
    'message--grid': this.grid,
    'message--can-close': this.canClose},
    _vm.objectModifiers)},[_vm._t("default"),_vm._v(" "),(_vm.canClose)?_c('button',{on:{"click":_vm.onClose}},[_c('sprite',{staticClass:"message__close",attrs:{"id":"app/close"}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }